import _ from 'lodash';
import { useEffect, useState } from 'react';
import { getSessionInfo } from './UserLogin';
import { useLoginState } from './LoginStateContext';

import { setAuthorizationToken, setLoggedInUserId } from './fetch-json.util';

export function useUserInfo() {
  const [loginState] = useLoginState();

  const [info, setInfo] = useState(getSessionInfo());

  useEffect(() => {
    const newState =
      loginState && Object.keys(loginState).length > 0 ? loginState : null;

    if (
      !info ||
      (newState &&
        (!_.isEqual(info.roles, newState.roles) ||
          info.token !== newState.token))
    ) {
      setInfo(newState);
    }
  }, [loginState]);

  if (info) {
    setAuthorizationToken(info.token);
    setLoggedInUserId(info.userId);
  }
  return info;
}
